export default theme => ({
    root: {
        flex: '1 1 100%',
        margin: 0,
    },
    popover: {
        zIndex: theme.zIndex.tooltip + 1,
    },
});
